import React from "react"

import { useBikeStore } from "hooks"
import { BackToStoreCard, BackToStoreRequestedCard } from "./BackToStore"
import { BuyCard, BuyRequestedCard } from "./Buy"
import { BACK_PROPERTY_TRANSFER_REQUEST, BUY_PROPERTY_TRANSFER_REQUEST } from "utils/constants"

export const BackAndBuyBike = () => {
    const { currentBike: bike } = useBikeStore()

    const isBackToStoreTransferRequested = bike?.propertyTransferRequest?.context === BACK_PROPERTY_TRANSFER_REQUEST
    const isBuyTransferRequested = bike?.propertyTransferRequest?.context === BUY_PROPERTY_TRANSFER_REQUEST

    return (
        <div className="flex justify-between mb-7">
            {!isBackToStoreTransferRequested && !isBuyTransferRequested &&
                <>
                    <BackToStoreCard />
                    <BuyCard />
                </>
            }

            {isBackToStoreTransferRequested && <BackToStoreRequestedCard />}

            {isBuyTransferRequested && <BuyRequestedCard />}
        </div>
    )
}
